<div class="widgetLine" *ngIf="appendixPageWidgetConfig">
  <table numberoflines="" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-with-space">
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>

        <th class="widget-grid-space">&nbsp;</th>

        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tr>
      <td colspan="33" class="widget-line-title-height widget-full-line-title-color-red">
        <div class="brush-left"></div>
        <div class="brush-center"></div>
        <div class="brush-right"></div>
        <div class="text-input" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflists['ref_l3_appendix_page_appendix_number']" style="width:30%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="appendixPageWidgetConfig.appendixNumberId"
                              (valueChange)="onValueChanged($event)">
          </kendo-dropdownlist>
          <kendo-dropdownlist [data]="reflists['ref_l3_appendix_page_appendix_description']" style="width:30%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="appendixPageWidgetConfig.appendixDescriptionId"
                              (valueChange)="onAppendixDescriptionSelected($event)">
          </kendo-dropdownlist>
          <input type="text" [(ngModel)]="appendixPageWidgetConfig.appendixDescriptionText" class="gridster-item-content" style="width:38%"
                 (ngModelChange)="onAppendixDescriptionTyped($event)" />
        </div>
        <div class="text-input text-input-view" *ngIf="!editMode">
          {{appendixPageWidgetConfig.appendixNumberId | rdReflist: reflists['ref_l3_appendix_page_appendix_number']}}: {{appendixPageWidgetConfig.appendixDescriptionText}}
        </div>
      </td>
    </tr>
  </table>
</div>
